import config from "@/config";
import {Cobrowse} from "@/modules/CobrowseWidget/Cobrowse";

/**
 * Directive for embedding the unblue co-browsing masking and protection from HTML elements
 *
 * @see https://www.unblu.com/en/docs/latest/knowledge-base/embedded-co-browsing-masking-and-hiding-webpage-elements.html#protecting-content
 *
 * @examples
 * `<div v-unblu-captured >...`  ==> only text input childs will be captured (asterisks placeholder instead of the content)
 * `<div v-unblu-protected >...` ==> only the elements mark as protected (shows lock icon)
 * `<div v-unblu-blocked >...`   ==> both will be set automatically
 * `<div v-unblu-hidden >...`    ==> hide the element for the agent
 */

export default {
  install (Vue) {

    const { $EventBus, i18n } = Vue.prototype
    const { unbluServerUrl, unbluApiKey } = config

    const cobrowseConfig = {
      url: unbluServerUrl,
      key: unbluApiKey,
      locale: i18n.locale
    }
    Vue.prototype.$cobrowse = new Cobrowse(cobrowseConfig, $EventBus)

    Vue.component('unblu-container', {
      template: '<div id="sanitas-cobrowsing"></div>'
    })

    Vue.directive('unblu-captured', {
      inserted: capturing,
      componentUpdated: capturing,
      unbind: el => capturing(el, { value: false })
    })

    Vue.directive('unblu-protected', {
      inserted: protecting,
      componentUpdated: protecting,
      unbind: el => protecting(el, { value: false })
    })

    Vue.directive('unblu-blocked', {
      inserted: (el, binding) => {
        capturing(el, binding)
        protecting(el, binding)
      },
      componentUpdated: (el, binding) => {
        capturing(el, binding)
        protecting(el, binding)
      },
      unbind: el => {
        capturing(el, { value: false })
        protecting(el, { value: false })
      }
    })

    Vue.directive('unblu-hidden', {
      inserted: hiding,
      componentUpdated: hiding,
      unbind: el => hiding(el, { value: false })
    })
  }
}

function capturing (el, binding) {
  const value = (binding?.value || true) ? 'block' : false
  toggleAttribute(el, 'unbluCapturingHint', value)

  if (![ 'INPUT', 'TEXTAREA' ].includes(el.tagName)) {
    const elements = Array.from(el.querySelectorAll('input, textarea, select'))
    elements.forEach(element => {
      toggleAttribute(element, 'unbluCapturingHint', value)
    })
  }
}

function protecting (el, binding) {
  const value = (binding?.value || true) ? 'block' : false
  toggleAttribute(el, 'unbluEditingHint', value)
}

function hiding (el, binding) {
  const value = (binding?.value || binding || true) ? 'true' : false
  toggleAttribute(el, 'x-unblu-skip-element', value)
}

function toggleAttribute (el, key, value) {
  if (value) {
    el.setAttribute(key, value)
  } else {
    el.removeAttribute(key)
  }
}

